import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { RequestEntity, IVideosByIDsRestaurantsForVideos } from 'types';
import {
	IVideosAssignmentContext,
	VideosAssignmentContext,
} from '../../../../../videosAssignmentState/videosAssignmentContext';
import ImgUploaderByEntityId from 'components/ImgUploader/ImgUploaderByEntityId';
import breadcrumbs from 'images/breadcrumbs.svg';
import classNames from 'classnames';
import style from './Video.module.scss';

interface IVideo {
	data: IVideosByIDsRestaurantsForVideos[];
	restaurantID: string;
}

const Video: React.FC<IVideo> = ({ data, restaurantID }) => {
	const { deleteVideoFromRestaurant } = useContext<IVideosAssignmentContext>(VideosAssignmentContext);

	return (
		<div data-test="Video">
			{data.map((el) => {
				const containerClasses = classNames(style.container, { [style.addedItem]: !el.restaurantAddress });

				return (
					<div className={containerClasses} key={el.videoId + 'videoTab'}>
						<div className={style.name}>
							<div className={style.imgWrapper}>
								<ImgUploaderByEntityId
									resource={RequestEntity.Videos}
									entityID={el?.iconPath ? el.videoId : ''}
									photoSize="Small"
									loaderSize="small"
									noImageIdIcon="videoDefaultAvatar"
								/>
							</div>
							<Text className={style.videoName} translationKey={el.videoName} withTooltip={true} />
						</div>
						<Text className={style.customer} translationKey={el.customerName} withTooltip={true} />
						<Text className={style.address} translationKey={el.restaurantAddress} withTooltip={true} />
						<svg
							className={style.closeIcon}
							onClick={() => deleteVideoFromRestaurant(restaurantID, el.videoId)}>
							<use xlinkHref={`${breadcrumbs}#close`} />
						</svg>
					</div>
				);
			})}
		</div>
	);
};

export default Video;
